<template>
  <section>
    <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(checkSave)">
        <div class="modal-card" style="width: 1080px">
          <header class="modal-card-head">
            <p v-if="update" class="modal-card-title">Editar Beca de estudio</p>
            <p v-else class="modal-card-title">Agregar Nueva Beca de estudio</p>
            <button type="button" class="delete" @click="$emit('close')" />
          </header>
          <section class="modal-card-body">
            <div class="columns">
              <div class="column">
                <div class="mb-2" v-if="Object.keys(errores_validacion).length !== 0">
                  <b-message type="is-danger" has-icon>
                    <div v-for="(item,index) in errores_validacion">
                      <div v-if="item">{{ item[0] }}</div>
                    </div>
                  </b-message>
                </div>
              </div>
            </div>

            <div class="columns">
              <div class="column">
                <ValidationProvider name="Carácter de la Beca" rules="min:3|max:255|required"
                  v-slot="{ errors, failedRules }">
                  <b-field label="Carácter de la Beca *" :type="{ 'is-danger': Object.keys(failedRules).length > 0 }"
                    :message="Object.keys(failedRules).length > 0 ? errors[0] : ''">
                    <b-input v-model="scholarship.name" placeholder="Ej: Aranceles, manutención, pasajes, etc." />
                  </b-field>
                </ValidationProvider>
              </div>

              <div class="column">
                <ValidationProvider name="Organismo Otorgante" rules="min:3|max:255|required" v-slot="{ errors, failedRules }">
                  <b-field :type="{ 'is-danger': isPartnerEntityRegister || Object.keys(failedRules).length > 0 }"
                    :message="{ 'Debe añadir una entidad registrada': isPartnerEntityRegister || Object.keys(failedRules).length > 0 }"
                    label="Organismo Otorgante *">
                    <b-autocomplete v-model="scholarship.partner_entity_name" :keep-first="keepFirst"
                      :open-on-focus="openOnFocus" :data="partner_entities" field="show_name" empty="Vacio"
                      @typing="searchPartnerEntities"
                      @select="option => {if (option) {scholarship.partner_entity_id = option.id} }"
                      :clearable="clearable" placeholder="Ej: CONICYT">
                      <template slot-scope="props">
                        {{ props.option.show_name ? props.option.show_name : props.option.name}}
                      </template>
                    </b-autocomplete>
                  </b-field>
                </ValidationProvider>
              </div>
              <div class="column is-narrow">
                <br>
                <b-field label=" ">
                  <b-tooltip label="Si la entidad que desea agregar no existe, la puede agregar presionando el botón +"
                    position="is-left">
                    <b-button class="is-primary is-outlined" @click="addEntity()">
                      <b-icon icon="plus"></b-icon>
                    </b-button>
                  </b-tooltip>
                </b-field>
              </div>
            </div>

            <div class="columns">
              <div class="column">
                <ValidationProvider name="Motivo del Estudio" rules="min:3|max:255|required" v-slot="{ errors, failedRules }">
                  <b-field label="Motivo del Estudio *" :type="{ 'is-danger': Object.keys(failedRules).length > 0 }"
                    :message="Object.keys(failedRules).length > 0 ? errors[0] : ''">
                    <b-input v-model="scholarship.study" placeholder="Ej: Postdoctorado en el extranjero" />
                  </b-field>
                </ValidationProvider>
              </div>

              <div class="column">
                <ValidationProvider name="Institución" rules="min:3|max:255|required" v-slot="{ errors, failedRules }">
                  <b-field label="Institución *"
                    :type="{ 'is-danger': isInstitutionRegister || Object.keys(failedRules).length > 0 }"
                    :message="{ 'Debe añadir una entidad registrada': isInstitutionRegister || Object.keys(failedRules).length > 0 }">
                    <b-autocomplete v-model="scholarship.institution_name" :keep-first="keepFirst"
                      :open-on-focus="openOnFocus" :data="institutions" field="show_name" empty="Vacio"
                      @typing="searchInstitutions"
                      @select="option => {if (option) {scholarship.institution_id = option.id} }" :clearable="clearable"
                      placeholder="Ej: Universidad de Valencia">
                      <template slot-scope="props">
                        {{ props.option.show_name ? props.option.show_name : props.option.name}}
                      </template>
                    </b-autocomplete>
                  </b-field>
                </ValidationProvider>
              </div>
              <div class="column is-narrow">
                <br>
                <b-field label=" ">
                  <b-tooltip label="Si la entidad que desea agregar no existe, la puede agregar presionando el botón +"
                    position="is-left">
                    <b-button class="is-primary is-outlined" @click="addEntityDos()">
                      <b-icon icon="plus"></b-icon>
                    </b-button>
                  </b-tooltip>
                </b-field>
              </div>
            </div>

            <div class="columns mb-6">
              <div class="column">
                <ValidationProvider name="Fecha de Inicio"
                  :rules="{ start_date_before_end_date: scholarship.end_date, required: true }"
                  v-slot="{ errors, failedRules }">
                  <b-field label="Fecha de Inicio *" :type="{ 'is-danger': Object.keys(failedRules).length > 0 }"
                    :message="Object.keys(failedRules).length > 0 ? errors[0] : ''">
                    <b-datepicker v-model="scholarship.start_date" icon="calendar-alt" trap-focus locale="es-ES"
                      editable placeholder="dd/mm/aaaa" />
                  </b-field>
                </ValidationProvider>
              </div>

              <div class="column">
                <ValidationProvider name="Fecha de Término"
                  :rules="{ end_date_not_before_start_date: scholarship.start_date }" v-slot="{ errors, failedRules }">
                  <b-field label="Fecha de Término" :type="{ 'is-danger': Object.keys(failedRules).length > 0 }"
                    :message="Object.keys(failedRules).length > 0 ? errors[0] : ''">
                    <b-datepicker v-model="scholarship.end_date" icon="calendar-alt" trap-focus locale="es-ES" editable
                      placeholder="dd/mm/aaaa">
                    </b-datepicker>
                  </b-field>
                </ValidationProvider>
              </div>
            </div>

            <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false" />
          </section>
        </div>
        <footer class="modal-card-foot is-flex is-justify-content-space-between">
          <b-button label="Cerrar" @click="$emit('close')" />
          <b-button label="Guardar Datos" type="is-primary" @click="checkSave()" />
        </footer>
        <b-modal v-model="isAddModalEntityActive" :destroy-on-hide="true" width="55%" :can-cancel="canCancel">
          <template #default="props">
            <modal_partner_entity query-type="update" modal-header="Añadir nueva entidad" @close="props.close"
              @clicked="onClickChild"></modal_partner_entity>
          </template>
        </b-modal>
        <b-modal v-model="isAddModalEntityActiveDos" :destroy-on-hide="true" width="55%" :can-cancel="canCancel">
          <template #default="props">
            <modal_partner_entity_dos query-type="update" modal-header="Añadir nueva entidad" @close="props.close"
              @clicked="onClickChildDos"></modal_partner_entity_dos>
          </template>
        </b-modal>
      </form>
    </ValidationObserver>
  </section>
</template>

<script>
import axios from "axios";
import modal_partner_entity from "../moduloVIME/agreements/new/modal_partner_entity"
import modal_partner_entity_dos from "../moduloVIME/agreements/new/modal_partner_entity"
import moment from "moment";

export default {
  name: "modal_new_scholarship",
  props: ['update','old_scholarship','personId'],
  components: {modal_partner_entity, modal_partner_entity_dos},
  created() {
    if(this.update){
      this.getScholarship()
    }
  },
  data(){
    return{
      isLoading: false,
      scholarship: {},
      keepFirst: false,
      openOnFocus: false,
      clearable: false,
      partner_entities:[],
      institutions: [],
      isAddModalEntityActive: false,
      isAddModalEntityActiveDos: false,
      canCancel: false,
      errores_validacion: {},
      isPartnerEntityRegister: false,
      partner_entity_name: '',
      isInstitutionRegister: false
    }
  },
  methods: {
    async getScholarship(){
      this.isLoading =  true
      await axios
          .get('/scholarships/'+this.old_scholarship.id+'.json')
          .then(response => {
            this.scholarship = response.data
            this.scholarship.start_date = moment(this.scholarship.start_date, ["YYYY-MM-DD","DD-MM-YYYY"])._d;
            if (this.scholarship.end_date != null){
              this.scholarship.end_date = moment(this.scholarship.end_date, ["YYYY-MM-DD","DD-MM-YYYY"])._d;
            }
          })
          .catch(error => {
            this.$buefy.dialog.alert({
              title: 'Error',
              message: 'Hubo un error al obtener los datos. Intente más tarde',
              type: 'is-danger',
              hasIcon: true,
              icon: 'times-circle',
              iconPack: 'fa',
              ariaRole: 'alertdialog',
              ariaModal: true
            })
            this.$emit('close')
          })
          .finally(() => {
              this.isLoading = false
          })
    },
    async checkSave(){
      const valid = await this.$refs.observer.validate()
      this.isPartnerEntityRegister = false
      if(!valid){
        this.$buefy.dialog.alert({
          message: 'Faltan algunos campos o presentan errores de formato.',
          type: 'is-danger',
          hasIcon: true,
          icon: 'times-circle',
          iconPack: 'fa',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
      else{
        if (this.scholarship.partner_entity_name != '' && this.scholarship.partner_entity_name != null) {
          if (this.scholarship.partner_entity_id == null) {
            this.isPartnerEntityRegister = true
          }
          else {
            if(this.scholarship.institution_name != '' && this.scholarship.institution_name != null){
              if (this.scholarship.institution_id == null) {
                this.isInstitutionRegister = true
              }
              else{
                this.saveScholarship()
              }
            }
            else{
              this.saveScholarship()
            }
          }
        }
        else{
          this.saveScholarship()
        }
      }
    },
    async saveScholarship(){
      this.isLoading = true
      this.scholarship.person_id = this.personId
      if(this.update){
        await axios
            .put('/scholarships/'+this.old_scholarship.id+'.json', {
              scholarship: this.scholarship
            })
            .then(response => {
              this.$buefy.dialog.alert({
                message: 'Los datos fueron actualizados satisfactoriamente.',
                confirmText: 'Ok'
              });
              this.errores_validacion = {}
              this.$emit('close')
              this.$emit('refresh')
            })
            .catch(error => {
              this.errores_validacion = error.response.data
              this.$buefy.dialog.alert({
                title: 'Error',
                message: 'Ocurrio un error al editar los datos.',
                type: 'is-danger',
                hasIcon: true,
                icon: 'times-circle',
              });
            })
            .finally(() => {
              this.isLoading = false
            })
      }
      else{
        await axios
            .post('/scholarships.json', {
              scholarship: this.scholarship
            })
            .then(response => {
              this.$buefy.dialog.alert({
                message: 'Los datos fueron guardados satisfactoriamente.',
                confirmText: 'Ok'
              });
              this.errores_validacion = {}
              this.$emit('close')
              this.$emit('refresh')
              this.isLoading = false
            })
            .catch(error => {
              this.errores_validacion = error.response.data
              this.isLoading = false
              this.$buefy.dialog.alert({
                title: 'Error',
                message: 'Ocurrio un error al guardar los datos.',
                type: 'is-danger',
                hasIcon: true,
                icon: 'times-circle',
              });
            })
            .finally(() => {
              this.isLoading = false
            })
      }
    },
    searchPartnerEntities(name){
      this.scholarship.partner_entity_id = null
      if (name.length<3) {
        this.partner_entities = []
        return
      }
      let vm = this;
      vm.isLoading=true;
      axios
          .get("/admin/partner_entities/agreement-search.json", { params: {
              name: name
            } })
          .then(res => {
            vm.partner_entities = res.data;
            this.errores_validacion = {}
          })
          .catch(error => {
            this.errores_validacion = error.response.data
          })
          .finally(() => {
            this.isLoading = false
          })
    },
    searchInstitutions(name){
      this.scholarship.institution_id = null
      if (name.length<3) {
        this.institutions = []
        return
      }
      let vm = this;
      vm.isLoading=true;
      axios
          .get("/admin/partner_entities/agreement-search.json", { params: {
              name: name
            } })
          .then(res => {
            vm.institutions = res.data;
            this.errores_validacion = {}
          })
          .catch(error => {
            this.errores_validacion = error.response.data
          })
          .finally(() => {
            this.isLoading = false
          })
    },
    clearEntity(){
      this.scholarship.partner_entity_id = null
      this.scholarship.partner_entity_name = null
    },
    onClickChild(value){
      this.isPartnerEntityRegister = false
      if(value.name != '' && value.name != null){
        this.scholarship.partner_entity_name = value.name
      }
      else{
        this.scholarship.partner_entity_name = value.full_name
      }
      this.scholarship.partner_entity_id = value.id
    },
    onClickChildDos(value){
      this.isPartnerEntityRegister = false
      if(value.name != '' && value.name != null){
        this.scholarship.institution_name = value.name
      }
      else{
        this.scholarship.institution_name = value.full_name
      }
      this.scholarship.institution_id = value.id
    },
    addEntity(){
      this.isAddModalEntityActive = true;
    },
    addEntityDos(){
      this.isAddModalEntityActiveDos = true;
    },
  }
}
</script>

<style scoped>

</style>